/** @module nav component entry */

import navComponent from './component.js'

export default angular.module('nav', [])
  .component('fancyNav', navComponent);



/** WEBPACK FOOTER **
 ** ./examples/nav/index.js
 **/